<div class="row">
  <div class="col-12">
    <h5>
        {{ 'RewriteRules' | translate }}
        <app-help tooltipKey="RewriteRulestTooltip" tooltipPlacement="bottom"/>
    </h5>
    <p style="margin-top: 10px">{{ 'RewriteRulesDescription' | translate }}</p>
    <hr style="margin-bottom: 0.8rem" />
  </div>
  <div class="col-md-12" style="margin-top: 10px; min-width: 1120px">
    <div *ngIf="disabled" class="bg-blue" style="margin-bottom: 10px; margin-top: -10px">
      {{ 'SubscribeTo.advanced' | translate }}
    </div>
    <div cdkDropList class="drag-list" (cdkDropListDropped)="dropRewrite($event)">
      <div class="add-site-table-header" id="rewrite-header">
        <span></span>
        <span
          >{{ 'Active' | translate }}&nbsp;
          <app-help tooltipKey="RuleActiveTooltip" tooltipPlacement="right"/>
        </span>
        <span
          >{{ 'Priority' | translate }}&nbsp;
          <app-help tooltipKey="RulePriorityTooltip" tooltipPlacement="right"/>
        </span>
        <span style="width: 66% !important; min-width: 560px">{{ 'RewriteRule' | translate }} </span>
        <span style="width: 30% !important">{{ 'Comments' | translate }}</span>
        <span style="width: 81px !important">Actions</span>
      </div>
      @for (rule of rewriteRules; track rule.id) {
      <div class="drag-container rewrite-rule">
        <div
          class="drag-box"
          cdkDrag
          [cdkDragDisabled]="isEditingRewriteRule() || rewriteRulesInProgress"
          [ngClass]="{ 'no-drag': isEditingRewriteRule() || rewriteRulesInProgress }"
        >
          <span class="grip-cell">
            <div *ngIf="!isEditingRewriteRule() || rewriteRulesInProgress" class="grip-container">
              <div class="grip-column">
                <div class="grip"></div>
                <div class="grip"></div>
                <div class="grip"></div>
              </div>
              <div class="grip-column">
                <div class="grip"></div>
                <div class="grip"></div>
                <div class="grip"></div>
              </div>
            </div>
          </span>
          <span class="active">
            <app-switch [(ngModel)]="rule.active" [disabled]="!rule.isEditing" [showLabels]="false"/>
          </span>
          <span
            title="{{ (isEditingRewriteRule() ? 'PriorityTooltipInEdit' : 'PriorityTooltipOutOfEdit') | translate }}"
          >
            <span>#{{ $index + 1 }}</span>
          </span>
          <span style="width: 66% !important; min-width: 560px">
            <i
              *ngIf="!isValidRewriteRegExp(rule.rewriteSource)"
              class="icofont icofont-warning regex-validation"
              container="body"
              placement="left"
              ngbTooltip="{{ 'InvalidRegExp' | translate }}"
            ></i>
            <i
              *ngIf="isValidRewriteRegExp(rule.rewriteSource)"
              class="icofont icofont-check regex-validation"
              container="body"
              placement="top"
              ngbTooltip="{{ 'ValidRegExp' | translate }}"
            ></i>
            <div class="form-group">
              <app-label label="SourceURI" tooltip="SourceURITooltip" tooltipPlacement="right" />
              <div class="input-group">
                <div
                  class="input-group-prepend"
                  ngbTooltip="{{ 'StartRegexpCircumflex' | translate }}"
                  container="body"
                >
                  <span class="input-group-text">^/</span>
                </div>
                <input
                  #rewriteRuleSourceElement
                  class="form-control"
                  type="text"
                  [(ngModel)]="rule.rewriteSource"
                  [disabled]="!rule.isEditing"
                  (paste)="onPasteSource($event, rule)"
                  (input)="computeRegExp(rule)"
                />
              </div>
            </div>
            <i class="icofont icofont-long-arrow-right"></i>
            <div class="form-group">
              <app-label label="DestinationURI" tooltipPlacement="right" tooltip="DestinationURITooltip" />
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">/</span>
                </div>
                <input
                  class="form-control"
                  [(ngModel)]="rule.rewriteDestination"
                  [disabled]="!rule.isEditing"
                  (paste)="onPasteDestination($event, rule)"
                  (input)="computeRegExp(rule)"
                  oninp
                />
              </div>
            </div>
          </span>
          <span style="width: 30% !important">
            <span [title]="rule.comment" *ngIf="!rule.isEditing">{{ rule.comment }}</span>
            <textarea
              *ngIf="rule.isEditing"
              placeholder="{{ 'CommentsOptional' | translate }}"
              [(ngModel)]="rule.comment"
              style="
                height: 100%;
                width: 100%;
                position: relative;
                top: -5px;
                border: 1px solid #dfdfdf;
                border-radius: 2px;
              "
              maxlength="255"
            ></textarea>
          </span>
          <span style="width: 80px !important; padding-right: 0; margin-right: 8px">
            <div class="flex-align-items rules-actions">
              <button
                *ngIf="!rule.isEditing"
                (click)="!isEditingRewriteRule() && !rewriteRulesInProgress && startRewriteEditing($index)"
                title="{{ 'LastUpdateAt' | translate }} : {{ rule.updatedAt | dateFormat }}"
                [ngStyle]="{
                  color: isEditingRewriteRule() || rewriteRulesInProgress ? '#dbd9da' : '#4099ff',
                  cursor: isEditingRewriteRule() || rewriteRulesInProgress ? 'default' : 'pointer',
                }"
                style="font-size: 17px"
                class="transparent-btn pointer icofont icofont-edit-alt mr-2"
              ></button>
              <button
                *ngIf="rule.isEditing"
                (click)="validateRewriteEditing(rule)"
                title="{{ 'Validate' | translate }}"
                [ngStyle]="{
                  color:
                    rule.rewriteSource.length === 0 || rule.rewriteDestination.length === 0 ? '#dbd9da' : '#4099ff',
                  cursor:
                    rule.rewriteSource.length === 0 || rule.rewriteDestination.length === 0 ? 'default' : 'pointer',
                }"
                style="font-size: 25px"
                class="transparent-btn pointer icofont icofont-check"
              ></button>
              <button
                *ngIf="!rule.isEditing"
                (click)="(!isEditingRewriteRule() || rule.isEditing) && deleteRewriteRule(rule)"
                title="{{ 'supprimer' | translate }}"
                [ngStyle]="{
                  color: isEditingRewriteRule() || rewriteRulesInProgress ? '#dbd9da' : '#e74c3c',
                  cursor: isEditingRewriteRule() || rewriteRulesInProgress ? 'default' : 'pointer',
                }"
                style="font-size: 17px"
                class="transparent-btn pointer icofont icofont-ui-delete mr-1"
              ></button>
              <button
                *ngIf="rule.isNew"
                (click)="(!isEditingRewriteRule() || rule.isEditing) && deleteRewriteRule(rule)"
                title="{{ 'Annuler' | translate }}"
                [ngStyle]="{
                  color: isEditingRewriteRule() && !rule.isEditing ? '#dbd9da' : '#e74c3c',
                  cursor: isEditingRewriteRule() && !rule.isEditing ? 'default' : 'pointer',
                }"
                style="font-size: 23px"
                class="transparent-btn pointer icofont icofont-close mr-1"
              ></button>
              <button
                *ngIf="rule.isEditing && !rule.isNew"
                (click)="cancelRewriteEditing(rule)"
                title="{{ 'CancelChanges' | translate }}"
                style="color: #e74c3c; font-size: 23px"
                class="transparent-btn pointer icofont icofont-close mr-1"
              ></button>
            </div>
          </span>
        </div>
        <div *ngIf="rule.isEditing" class="tester">
          <h6>{{ 'RewriteTester' | translate }}</h6>
          <div class="flex-align-items" style="margin-top: 20px">
            <input
              #rewriteTest
              placeholder="{{ 'URLToTest' | translate }}"
              (input)="computeRegExp(rule)"
              style="width: 400px; margin-right: 20px"
            />
            <i class="icofont icofont-long-arrow-right" style="margin-right: 20px; font-size: 35px"></i>
            <p>{{ 'Result' | translate }} :&nbsp;&nbsp;</p>
            <input
              [value]="testURL == undefined ? ('EnterURLToTest' | translate) : testURL"
              disabled
              style="width: 400px"
            />
          </div>
        </div>
      </div>
      }
      <div *ngIf="!rewriteRules.length" style="text-align: center; padding: 15px">
        {{ 'NoRewriteRules' | translate }}
      </div>
    </div>
    <br />
    <div style="margin-bottom: 10px">
      <a *ngIf="!isEditingRewriteRule() && !isCreatingRewriteRule()" class="ogo-link" (click)="addRewriteRule()"
        >+ {{ 'AddARule' | translate }}</a
      >
    </div>
  </div>
</div>
